import React, { FC } from 'react';
import { Modal } from 'antd';
import { Close } from 'common/svg';
import { InfoTooltip } from 'common/components/InfoTooltip';
import { IOosOpportunityLossCategoryGroup } from 'entities/MonitorSales/MonitorSales.models';
import { OosOpportunityLossCategoryGroup } from 'entities/MonitorSales/components/OosOpportunityLossCategoryGroup';
import { CategoryColorLegend } from 'entities/MonitorSales/components/CategoryColorLegend';

interface IComponentProps {
  open: boolean;
  categoryGroups: IOosOpportunityLossCategoryGroup[];
  maxPotentialSalesLost: number;
  onCancel: () => void;
}

export const OosOpportunityLossModal: FC<IComponentProps> = ({
  open,
  categoryGroups,
  maxPotentialSalesLost,
  onCancel,
}) => {
  return (
    <Modal
      open={open}
      rootClassName="modal ms-oos__modal"
      classNames={{ body: 'scrollbar-y' }}
      width={480}
      centered
      closeIcon={<Close className="icon-gray" />}
      onCancel={onCancel}
      footer={null}
      title={
        <div className="ms-oos__modal-title">
          <span className="mr-2 ff-medium fs-xs">OOS Opportunity Loss</span>
          <InfoTooltip
            title={
              <div>
                <div className="mb-3 ff-medium fs-xxs">OOS Opportunity Loss</div>
                <div className="mb-4 ff-medium fs-xxxs color-gray-1">See how much you lost due to out-of-stock!</div>
                <CategoryColorLegend />
              </div>
            }
          />
        </div>
      }
    >
      <div>
        {categoryGroups.map((group) => (
          <div key={group.category} className="mb-6">
            <OosOpportunityLossCategoryGroup categoryGroup={group} maxPotentialSalesLost={maxPotentialSalesLost} />
          </div>
        ))}
      </div>
    </Modal>
  );
};
